import { render, staticRenderFns } from "./KerryThTip.pug?vue&type=template&id=6a86f200&scoped=true&lang=pug&"
import script from "./KerryThTip.vue?vue&type=script&lang=js&"
export * from "./KerryThTip.vue?vue&type=script&lang=js&"
import style0 from "./KerryThTip.scss?vue&type=style&index=0&id=6a86f200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a86f200",
  null
  
)

export default component.exports